import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import RoomOccupyReport from '../components/report/RoomOccupyReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomOccupyReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <RoomOccupyReport
          intl={intl}
          dispatch={dispatch}
          roomOccupyReport={roomOccupyReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/RoomOccupyReport.js